module.exports = __webpack_public_path__ + "media/images/premium/premium-main-71f1752977cb150305dffce6e6c2a88c.jpg";